import SysButtons from "config/lang/SysButtons";

const Buttons = {
  ...SysButtons,
};

export default Buttons;
